import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    IconButton,
    Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getReportComponentByKey, getReportKeyByName, getReportDisplayName } from "./customReportConfig";

export default function CustomReportViewer(props) {
    const { open, onClose, report } = props;

    const handleClose = () => {
        onClose();
    };

    // Map base report names/keys to their components
    const getReportComponent = () => {
        const baseReportNameOrKey = report.base_report;
        
        // Convert name to key (handles both new names, legacy names, and keys)
        const reportKey = getReportKeyByName(baseReportNameOrKey);
        
        // Create a wrapper for the report component that uses a custom gridId
        // This allows each custom report to have its own saved column settings
        // Use negative IDs to avoid any collision with standard report IDs (which are positive)
        // Standard reports use positive IDs like 38, 41, 42, 71, 72, 73
        // Custom reports will use negative IDs: -1, -2, -3, etc.
        const customGridId = -report.id;
        
        console.log('CustomReportViewer - base_report:', baseReportNameOrKey, 'reportKey:', reportKey, 'customGridId:', customGridId);
        
        // Pass a modified version of props that includes the custom gridId override
        // Also ensure comp_id is available for reports that expect it
        const customProps = {
            ...props,
            customReportGridId: customGridId,
            isCustomReport: true,
            comp_id: props.user?.comp_id
        };
        
        // Get the report component using the key
        const ReportComponent = reportKey ? getReportComponentByKey(reportKey) : null;
        
        if (ReportComponent) {
            return <ReportComponent {...customProps} />;
        }
        
        // Fallback for unsupported report types
        return (
            <Box sx={{ p: 3, textAlign: "center" }}>
                <Typography color="textSecondary">
                    Report type not supported yet: {baseReportNameOrKey}
                </Typography>
            </Box>
        );
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={false}
            fullWidth
            PaperProps={{
                sx: {
                    height: "90vh",
                    maxHeight: "90vh"
                }
            }}
        >
            <DialogTitle sx={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0"
            }}>
                <Box>
                    <Typography variant="h6" fontWeight="bold">
                        {report.report_name}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        Based on: {getReportDisplayName(report.base_report)}
                    </Typography>
                </Box>
                <IconButton onClick={handleClose} edge="end">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto', overflowX: 'hidden' }}>
                <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                    {getReportComponent()}
                </Box>
            </DialogContent>
        </Dialog>
    );
}
